import React, { PropTypes } from 'react';
import { routerShape, withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PrintButtonsToolbar, PrintTable, PrintLoadNextButton } from '@bibliocommons/print';
import { paginationShape, checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

import FormatInfo from '@bibliocommons/shared-format-info';
import BibBrief from '@bibliocommons/shared-bib-brief';
import CheckedOutStatusOverview from '../CheckedOutStatusOverview';

const renderFormat = (format, index, item) => (
  <FormatInfo item={item.get('bib')} showLanguage={false} />
);

const renderStatus = (status, index, item) => (
  <CheckedOutStatusOverview item={item} />
);

const renderTitle = (title, index, item) => (
  <BibBrief
    bib={item.getIn(['bib', 'briefInfo'])}
    titleTag="span"
    renderTitleAsLink={false}
    renderAuthorsAsLink={false} />
);

import './CheckedOutPrintList.scss';

export class CheckedOutPrintList extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleUpdatePage');
  }

  handleUpdatePage() {
    const { router, pagination } = this.props;
    const { location } = router;
    const newPage = pagination.get('page') + 1;
    router.push({ ...location, query: { ...location.query, page: newPage } });
  }

  render () {
    const { pagination, items, isFetching } = this.props;
    return (
      <div className="cp-checked-out-print-list">
        <PrintButtonsToolbar numItemsToPrint={items.size}>
          <PrintLoadNextButton
            handleClick={this.handleUpdatePage}
            numToLoad={pagination.get('limit')}
            totalPages={pagination.get('pages')}
            currentPage={pagination.get('page')}
            isLoading={isFetching} />
        </PrintButtonsToolbar>

        <h1><FormattedMessage id="section_title_checkedout" /></h1>

        <FormattedMessage id="label_number_of_items" values={{ count: items.size }}>
          {(message) => <p>{message}</p>}
        </FormattedMessage>

        <PrintTable
          rows={items}
          fields={[
            { key: 'bib.briefInfo.title', type: 'item-title', headerKey: 'table_headings_title', transformationMap: renderTitle },
            { key: 'bib.briefInfo.format', type: 'item-format', headerKey: 'table_headings_format', transformationMap: renderFormat },
            { key: 'bib.briefInfo.callNumber', type: 'item-callNumber', headerKey: 'callNumber' },
            { key: 'barcode', type: 'item-barcode', headerKey: 'form_label_barcode' },
            { key: 'status', type: 'item-status', headerKey: 'status_overview', transformationMap: renderStatus }
          ]} />
        <div className="page-info">
          <FormattedMessage id="form_label_current_page" values={{ current_page: pagination.get('page') }} />
          &nbsp;
          <FormattedMessage id="form_label_total_pages" values={{ total_pages: pagination.get('pages') }} />
        </div>
      </div>
    );
  }
}

CheckedOutPrintList.propTypes = {
  isFetching: PropTypes.bool,
  items: ImmutablePropTypes.listOf(checkedOutItemShape),
  pagination: paginationShape,
  router: routerShape
};

export default withRouter(CheckedOutPrintList);



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutPrintList/CheckedOutPrintList.jsx